import { Stack, Tooltip } from '@mui/material';

import PromotionalProductIcon from 'src/assets/icons/promotional-product-icon';

export default function PromotionalProductLabel() {
  return (
    <Tooltip title="Promotion">
      <Stack justifyContent="center" alignItems="center" minWidth={32}>
        <PromotionalProductIcon width={32} />
      </Stack>
    </Tooltip>
  );
}
